// components/Assessment/RiskQuestionnaire.jsx - STYLED TO MATCH CapacityForLoss
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RiskQuestionnaire = ({ questions, answers, onAnswer }) => {
    return (
        <div>
            {questions.map((question, qIndex) => (
                <div key={question.id} className="question-card capacity-card">
                    <div className="d-flex align-items-start mb-3">
                        <span className="question-number bg-primary text-white">{qIndex + 1}</span>
                        <div>
                            <span className="question-text">{question.text}</span>
                            {question.helpText && (
                                <div className="text-muted small mt-1">{question.helpText}</div>
                            )}
                        </div>
                    </div>

                    <div className="options-list">
                        {question.options.map((option, oIndex) => (
                            <button
                                key={oIndex}
                                className={`option-btn ${answers[question.id] === oIndex ? 'selected' : ''}`}
                                onClick={() => onAnswer(question.id, oIndex)}
                            >
                <span className="option-indicator">
                  {answers[question.id] === oIndex ? (
                      <FontAwesomeIcon icon="check" />
                  ) : (
                      String.fromCharCode(65 + oIndex)
                  )}
                </span>
                                <span>{option.text}</span>
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RiskQuestionnaire;